import { createSlice } from "@reduxjs/toolkit";

const newsLetterSlice = createSlice({
  name: "newsLetter",
  initialState: {
    loading: false,
  },
  reducers: {
    newsLetterRequest(state, action) {
      return {
        ...state,
        loading: true,
      };
    },
    newsLetterSuccess(state, action) {
      return {
        ...state,
        loading: false,
        newsLetterEmail: action.payload.allmails,
      };
    },
    newsLetterFail(state, action) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },
    newsLetterCreateRequest(state, action) {
      return {
        ...state,
        loading: true,
      };
    },
    newsLetterCreateSuccess(state, action) {
      return {
        ...state,
        loading: false,
        createletter: action.payload,
      };
    },
    newsLetterCreateFail(state, action) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },
    getAllnewsLetterRequest(state, action) {
      return {
        ...state,
        loading: true,
      };
    },
    getAllnewsLetterSuccess(state, action) {
      return {
        ...state,
        loading: false,
        AllNewsLetter: action.payload,
      };
    },
    getAllnewsLetterFail(state, action) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },
    DeleteNewsLetterRequest(state, action) {
      return {
        ...state,
        loading: true,
      };
    },
    DeleteNewsLetterSuccess(state, action) {
      return {
        ...state,
        loading: false,
        deletedNL: action.payload,
      };
    },
    DeleteNewsLetterFail(state, action) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },
  },
});
const { actions, reducer } = newsLetterSlice;

export const {
  newsLetterFail,
  newsLetterRequest,
  newsLetterSuccess,
  newsLetterCreateFail,
  newsLetterCreateRequest,
  newsLetterCreateSuccess,
  getAllnewsLetterFail,
  getAllnewsLetterRequest,
  getAllnewsLetterSuccess,
  DeleteNewsLetterFail,
  DeleteNewsLetterRequest,
  DeleteNewsLetterSuccess,
} = actions;

export default reducer;
